import profileService from '@/services/profileService'
import { authCreators } from '@/store/ducks/auth'
import { useAppDispatch } from '@/store/hooks'
import { useEffect } from 'react'

export function useWatchProfile() {
	const dispatch = useAppDispatch()

	const {
		data: profileData,
		isSuccess: isSuccessProfile,
		isLoading,
		refetch,
	} = profileService.getProfile()

	useEffect(() => {
		if (isSuccessProfile && profileData)
			dispatch(authCreators.setUser(profileData))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [profileData, isSuccessProfile])

	return { refetch, isLoading }
}
